import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

function errorHandler(apiFn) {
  return async (...args) => {
    try {
      return await apiFn(...args);
    } catch (err) {
      throw err;
    }
  };
}

const createTicket = errorHandler(async (supportData) => {
  const token = getAuthToken();

  const formData = new FormData();
  // console.log("support data: ", supportData);
  formData.append("type", supportData.type);
  formData.append("details", supportData.details);
  formData.append("impactLevel", supportData.impactLevel);
  formData.append("image", supportData.image);

  const data = await api.post("/support-tickets", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

const getTickets = errorHandler(async () => {
  const token = getAuthToken();
  const data = await api.get("/support-tickets/admin/all", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

const getMyTicket = errorHandler(async () => {
  const token = getAuthToken();
  const data = await api.get("/support-tickets/my-tickets", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

const getTicketById = errorHandler(async (id) => {
  const token = getAuthToken();
  const data = await api.get(`/support-tickets/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

const replyTicket = errorHandler(async (id, ticketData) => {
  const token = getAuthToken();
  const data = await api.post(`/support-tickets/${id}/reply`, ticketData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});
const deleteTicket = errorHandler(async (id) => {
  const token = getAuthToken();
  const data = await api.delete(`/support-tickets/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

export {
  createTicket,
  getTickets,
  getMyTicket,
  getTicketById,
  replyTicket,
  deleteTicket,
};
